/**
 * Created by vtbelo on 01.04.2021
 */

const UnitsShopTab = function (tab) {
    cleverapps.EventEmitter.call(this);

    this.tab = tab;
    this.load({});
};

UnitsShopTab.prototype = Object.create(cleverapps.EventEmitter.prototype);
UnitsShopTab.prototype.constructor = UnitsShopTab;

UnitsShopTab.prototype.load = function (stored) {
    this.stored = stored || {};
    this.buyed = {};
    this.inited = false;
    this.clear();
};

UnitsShopTab.prototype.save = function () {
    if (!this.inited) {
        return Object.keys(this.stored).length > 0 ? this.stored : undefined;
    }

    if (this.getLeftTime() > 0) {
        const info = {
            refresh: this.refreshTime,
            fresh: !!this.fresh
        };
        cleverapps.override(info, this.buyed);
        return info;
    }
};

UnitsShopTab.prototype.init = function () {
    if (this.inited) {
        return;
    }
    this.inited = true;

    if (this.stored) {
        this.refreshTime = this.stored.refresh || 0;
        this.fresh = this.stored.fresh || false;

        delete this.stored.refresh;
        delete this.stored.buyed;
        delete this.stored.fresh;

        this.buyed = this.stored;
        this.runRefreshTimeout();
    } else {
        this.refreshProducts();
    }
};

UnitsShopTab.prototype.clear = function () {
    if (this.refreshTimeout) {
        clearTimeout(this.refreshTimeout);
    }
};

UnitsShopTab.prototype.getLeftTime = function () {
    return this.refreshTime + cleverapps.parseInterval(UnitsShop.PRODUCTS[this.tab].refreshTimeout) - Date.now();
};

UnitsShopTab.clearCardRewards = function () {
    if (UnitsShop.cartRewards) {
        UnitsShop.cartRewards = undefined;
    }
};

UnitsShopTab.processCartUnits = function (cart) {
    if (UnitsShop.cartRewards && UnitsShop.cartRewards.length) {
        UnitsShop.cartRewards.forEach((reward) => {
            reward.collectRewardsAnimation(cart.firstItem);
        });
        UnitsShop.cartRewards = undefined;
    }
};

UnitsShopTab.getCartAmount = function () {
    if (!UnitsShop.cartRewards) {
        return 0;
    }
    return UnitsShop.cartRewards.reduce((amount, reward) => amount + reward.getAmount(), 0);
};

UnitsShopTab.prototype.buy = function (product, videoBonus) {
    this.buyed[product.itemId] = (this.buyed[product.itemId] || 0) + 1;

    cleverapps.user.incProgressCompare();
    cleverapps.unitsShop.save();

    if (!product.price) {
        PushHelper.sendPush(PUSHES.FREE_CHEST, this.getLeftTime());
    }

    if (!UnitsShop.cartRewards) {
        UnitsShop.cartRewards = [];
    }

    const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SALEPASS);
    const isSalePassActive = mission && !mission.logic.isAllTasksCompleted() && MissionManager.hasProperLocation(mission.type);
    const isClanCupActive = cleverapps.clanCup && cleverapps.clanCup.isRunning();

    for (let i = videoBonus ? 2 : 1; i > 0; --i) {
        product.unit.forEach((unitProduct) => {
            const unitReward = new Reward("units", unitProduct);
            unitReward.receiveReward();

            if (product.price <= 0 || product.price === undefined) {
                Map2d.mapEvent(Map2d.BUY_FREE_UNIT, { tab: this.tab });
            }

            if (isSalePassActive && product.salePassPoints) {
                unitReward.spawnedUnits.forEach((unit) => {
                    unit.setPoints(product.salePassPoints);
                });
            }

            if (isClanCupActive) {
                const cupStars = Unit.CalcCupStars(unitProduct);
                if (cupStars) {
                    unitReward.cupStars = {
                        unit,
                        reward: new Reward("cup", {
                            type: CupsConfig.TYPE_CLAN,
                            amount: cupStars
                        })
                    };
                    unitReward.cupStars.reward.receiveReward();
                }
            }

            UnitsShop.cartRewards.push(unitReward);
        });
    }

    if (Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive() && Map2dLocation.currentLocation.tutorial.getCurrentStepType() === Map2d.BUY_FREE_UNIT && Map2d.currentMap.advice) {
        Map2d.currentMap.advice.stopHint();
    }

    this.trigger("stateChanged");
    this.trigger("onBought");

    cleverapps.toolbar.resetByType(ToolbarItem.UNIT_SHOP);
};

UnitsShopTab.prototype.runRefreshTimeout = function () {
    if (this.getLeftTime() > 0) {
        this.clear();
        this.refreshTimeout = new cleverapps.LongTimeout(this.refreshProducts.bind(this, true), this.getLeftTime());
    } else {
        this.refreshProducts(true);
    }
};

UnitsShopTab.prototype.getFreeProduct = function () {
    this.init();

    return this.generateProducts().filter((product) => !product.price && product.left > 0)[0];
};

UnitsShopTab.prototype.generateProducts = function () {
    const config = UnitsShop.PRODUCTS[this.tab];

    const pseudo = PseudoRandom.GET("unitsshop");
    pseudo.seed(this.refreshTime);

    let products = [];

    const hero = cleverapps.unitsLibrary.getCurrentHero();

    if (config.hero_template && hero && hero !== "dwarf") {
        config.hero_template.forEach((template) => {
            products.push(this.fillTemplate(template, { code: hero }));
        });
    }

    if (config.tutorial_template && cleverapps.tutorial.isActive()) {
        config.tutorial_template.forEach((template) => {
            products.push(this.fillTemplate(template, { tutorial: true }));
        });
    }

    if (config.default) {
        config.default.forEach((template) => products.push(this.fillTemplate(template)));
    }

    if (config.fruit_template) {
        config.fruit_template.forEach((template) => {
            const codes = cleverapps.unitsLibrary.listAvailableByType("fruit");

            for (let i = 0; i < codes.length; i++) {
                products.push(this.fillTemplate(template, { code: codes[i] }));
            }
        });
    }

    const resource = cleverapps.unitsLibrary.getCurrentCastleResource();

    if (config.resource_template && resource) {
        const resourceData = config.resource_data[resource] || config.resource_data.default;
        for (let i = 0, price = resourceData.basicPrice; i < resourceData.stages; i++, price *= 3) {
            products.push(this.fillTemplate(config.resource_template, {
                code: resource,
                stage: i,
                price
            }));
        }
    }

    if (config.line_template) {
        config.line_template.forEach(function (template) {
            const codes = cleverapps.unitsLibrary.listAvailableByType(template.codes);
            let chosen = codes.filter((code) => !template.preferUndone || cleverapps.unitsLibrary.getLastOpenStage(code) < Families[code].units.length - 1);
            chosen = chosen.length > 0 ? chosen : codes;

            if (template.randomChoose) {
                const shortage = template.randomChoose - chosen.length;
                if (shortage > 0) {
                    chosen = chosen.concat(cleverapps.substract(codes, chosen).slice(0, shortage));
                }
                pseudo.seed(this.refreshTime);
                chosen = pseudo.chooseN(chosen, template.randomChoose);
            }

            for (let i = 0; i < chosen.length; i++) {
                if (config.cheap_line_template) {
                    let lastStage = cleverapps.unitsLibrary.getLastOpenStage(chosen[i]) || 0;
                    if (lastStage > 0) {
                        pseudo.seed(this.refreshTime);
                        lastStage = pseudo.choose([lastStage - 1, lastStage]);
                    }

                    const cheapPrice = Math.round(1.5 * Math.pow(1.7, lastStage));

                    products.push(this.fillTemplate(config.cheap_line_template, {
                        code: chosen[i],
                        stage: lastStage,
                        price: cheapPrice
                    }));

                    if (config.expansive_line_template) {
                        products.push(this.fillTemplate(config.expansive_line_template, {
                            code: chosen[i],
                            stage: lastStage,
                            price: 2 * cheapPrice
                        }));
                    }

                    continue;
                }

                products.push(this.fillTemplate(template, { code: chosen[i] }));
            }
        }, this);
    }

    products = products.filter(Boolean);

    const randomProducts = products.filter((product) => product.groupId === undefined);

    if (randomProducts.length !== products.length) {
        products.sort((p1, p2) => {
            if (p1.groupId !== p2.groupId) {
                return p1.groupId - p2.groupId;
            }
            pseudo.seed(this.refreshTime);
            return pseudo.nextDouble() - 0.5;
        });
        let prevGroup;
        products.forEach((product) => {
            if (product.groupId !== undefined && product.groupId !== prevGroup) {
                prevGroup = product.groupId;
                randomProducts.push(product);
            }
        });
        products = randomProducts;
    }

    const mission = cleverapps.missionManager.findByType(Mission.TYPE_SALEPASS);
    if (mission && mission.isRunning() && !mission.logic.isAllTasksCompleted() && MissionManager.hasProperLocation(mission.type)) {
        products.forEach((product) => {
            let points;

            switch (product.type) {
                case Product.TYPE_HARD: points = product.price * 3; break;
                case Product.TYPE_SOFT: points = product.price / 11; break;
            }

            if (points) {
                const amount = product.unit.reduce((amount, unit) => amount + unit.amount, 0);
                product.salePassPoints = Math.max(5, Math.ceil(Math.floor(points / 5) * 5 / amount));
            }
        });
    }

    if (Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive() && Map2dLocation.currentLocation.tutorial.getCurrentStepType() === Map2d.BUY_FREE_UNIT) {
        products.forEach((product) => {
            if (product.videoBonus) {
                product.videoBonus = false;
            }
        });
    }

    return products;
};

UnitsShopTab.prototype.fillTemplate = function (template, options) {
    options = options || {};

    template = cleverapps.clone(template, true);

    const location = cleverapps.meta.getSelectedLocation();

    template.tutorial = options.tutorial;

    template.tab = this.tab;
    template.price = template.price || options.price || 0;

    template.unit = cleverapps.toArray(template.unit || []).map((unitTemplate) => {
        let code = unitTemplate.code || options.code;
        const stage = unitTemplate.stage || options.stage || 0;
        const amount = unitTemplate.amount || 1;

        if (unitTemplate.type === "fruit") {
            code = cleverapps.unitsLibrary.getCurrentFruit();
        } else if (unitTemplate.type === "resourcechest") {
            code = `${cleverapps.unitsLibrary.getCurrentCastleResource()}chest`;
        }

        const family = Families[code];
        if (!family) {
            return;
        }

        if (location.families && !location.families[code]
            || unitTemplate.onlyIfOpen && !cleverapps.unitsLibrary.hasOpened(code)
            || unitTemplate.onlyIfNotDone && cleverapps.unitsLibrary.getLastOpenStage(code) >= family.units.length - 1
            || unitTemplate.landmarkDonor && !(Map2dLocation.currentLocation && Map2dLocation.currentLocation.landmarks && Map2dLocation.currentLocation.landmarks.isActiveDonor({ code, stage }))) {
            return;
        }

        return { code, stage, amount };
    }).filter(Boolean);

    if (!template.unit.length) {
        return;
    }

    template.itemId = `${template.unit[0].code}_${template.unit[0].stage}_${template.unit[0].amount}`;

    if (!template.tutorial) {
        template.left -= this.buyed[template.itemId] || 0;
    }

    // Single- vs multi-unit tile is chosen by the unit count (old UnitsShopTileModel.getViewClassName).
    template.prefab = template.unit.length > 1
        ? bundles.tile_shop.jsons.unitsshopmultitile_prefab_json
        : bundles.tile_shop.jsons.unitsshoptile_prefab_json;

    // Free units draw attention while stock remains (old isFree() && isAvailable(); a free unit is
    // never an ADS product, so availability reduces to stock left).
    template.isAttention = function () {
        return this.type === Product.TYPE_FREE && this.left > 0;
    };

    return template;
};

UnitsShopTab.prototype.countBoughtProducts = function () {
    const freeProducts = this.generateProducts().filter((product) => !product.price);

    const freeKeys = freeProducts.map((product) => product.itemId);

    let amount = 0;
    for (const boughtKey in this.buyed) {
        if (freeKeys.indexOf(boughtKey) === -1) {
            amount += this.buyed[boughtKey];
        }
    }

    return amount;
};

UnitsShopTab.prototype.buyRefresh = function () {
    if (this.countBoughtProducts() > 0) {
        if (cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.REFRESH, UnitsShop.PRODUCTS[this.tab].refreshPrice)) {
            this.refreshProducts();
            return true;
        }
    }
    return false;
};

UnitsShopTab.prototype.refreshProducts = function (fresh) {
    this.refreshTime = cleverapps.getCooldownStartTime(UnitsShop.PRODUCTS[this.tab].refreshTimeout);

    this.buyed = {};
    this.fresh = fresh;
    this.runRefreshTimeout();
    cleverapps.unitsShop.save();

    const products = this.generateProducts();
    products.forEach((product) => {
        if (product.type === Product.TYPE_ADS) {
            cleverapps.dataLoader.remove(DataLoader.TYPES.PRODUCT_VIDEO_PROGRESS + product.itemId);
        }
    });

    PushHelper.cancelPush(PUSHES.FREE_CHEST);
    this.trigger("stateChanged");
    cleverapps.toolbar.resetByType(ToolbarItem.UNIT_SHOP);
};

UnitsShopTab.prototype.setFreshShown = function () {
    if (this.fresh) {
        this.fresh = false;
        this.trigger("stateChanged");
        cleverapps.unitsShop.save();
    }
};
